import { frontendVersion } from '../../../appVersion';
import { isLacAdmin } from '../../../auth/roles';
import { useAuth } from '../../../auth/useAuth';
import { LiksCard } from '../../../components/liks/LiksCard/LiksCard';
import { useAppVersionsQuery } from '../../../features/systemInfo/queries/useAppVersionsQuery';
import { useI18n } from '../../../i18n/useI18n';

function resolveRemoteVersion(
  value: string | undefined,
  isLoading: boolean,
  isError: boolean,
  labels: {
    loading: string;
    unavailable: string;
  },
): string {
  if (isLoading) {
    return labels.loading;
  }

  if (isError || value == null || value === '') {
    return labels.unavailable;
  }

  return value;
}

export function SettingsAppInfoTab() {
  const { user } = useAuth();
  const { translate } = useI18n();
  const showLacVersion = isLacAdmin(user);
  const versionsQuery = useAppVersionsQuery({
    includeLacService: showLacVersion,
  });

  const remoteLabels = {
    loading: translate('settings.appInfo.loading'),
    unavailable: translate('settings.appInfo.unavailable'),
  };

  return (
    <LiksCard
      title={translate('settings.appInfo.title')}
      description={translate('settings.appInfo.description')}
    >
      <dl className="settings-page__version-list">
        <div className="settings-page__version-item">
          <dt>{translate('settings.appInfo.frontend')}</dt>
          <dd>{frontendVersion}</dd>
        </div>
        <div className="settings-page__version-item">
          <dt>{translate('settings.appInfo.backendService')}</dt>
          <dd>
            {resolveRemoteVersion(
              versionsQuery.data?.backendService,
              versionsQuery.isLoading,
              versionsQuery.isError,
              remoteLabels,
            )}
          </dd>
        </div>
        {showLacVersion && (
          <div className="settings-page__version-item">
            <dt>{translate('settings.appInfo.lacService')}</dt>
            <dd>
              {resolveRemoteVersion(
                versionsQuery.data?.lacService,
                versionsQuery.isLoading,
                versionsQuery.isError,
                remoteLabels,
              )}
            </dd>
          </div>
        )}
      </dl>
    </LiksCard>
  );
}
